import useFetch from "v4/hooks/useFetch";
import {useEffect} from "react";
import {generateUrl} from "v4/services/api.service";
import {IMPORT_PROCESS} from "v4/data/apiRoutes";
import {useParams} from "react-router-dom";
import useImportRedirect from "v4/pages/admin/Import/components/ImportSteps/hooks/useImportRedirect";
import {useImportContext} from "v4/pages/admin/Import/contexts/ImportContext";
import useNotification from "v4/hooks/useNotification";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {sendBrowserNotification} from "v4/components/utils/NotifyMe/utils/sendBrowserNotification";

export default function useProcessImport() {
    const {t} = usePolTranslation();
    const {id: importId} = useParams();
    const [{data, isError, errorData}, fetchProcess] = useFetch();
    const {prevStep} = useImportContext();
    const {addErrorNotification} = useNotification();

    useEffect(() => {
        fetchProcess({
            url: generateUrl(IMPORT_PROCESS, {importId}),
        });
    }, [fetchProcess, importId]);

    useEffect(() => {
        if (!data && !isError) return;

        if (!isError) {
            sendBrowserNotification(t('import_completed_successfully'), { tag: 'pol-import' });
            return;
        }

        if (errorData?.messages?.errors?.length) {
            addErrorNotification(errorData.messages.errors.map(error => t(error)).join(' '));
        }

        sendBrowserNotification(t('error_import'), { tag: 'pol-import' });
        prevStep();
    }, [addErrorNotification, data, errorData, isError, prevStep, t]);


    useImportRedirect(data?.import.state);
}
